// @react/hooks/useUserReferral.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { userReferralStore } from '@core/stores';

/**
 * React hook for User operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useUserReferral } from '@react/hooks';
 *
 * const UserList = observer(() => {
 *   const store = useUserReferral();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useUserReferral() {
  return userReferralStore;
}
